import { c as _c } from "react/compiler-runtime";
import GridRow from "@/components/common/grid-row/grid-row";
import GridColumn from "@/components/common/grid-column/grid-column";
import SuperTitle from "@/components/common/supertitle/supertitle";
import { ComparisonTable as ComparisonTableType } from "@/sanity/sanity.types";
interface IComparisonTableProps {
  data: ComparisonTableType;
}
const ComparisonTable = t0 => {
  const $ = _c(44);
  const {
    data
  } = t0;
  const {
    eyebrow,
    heading,
    subheading,
    columns,
    rows
  } = data;
  let t1;
  if ($[0] !== eyebrow) {
    t1 = eyebrow && <SuperTitle>{eyebrow}</SuperTitle>;
    $[0] = eyebrow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== heading) {
    t2 = heading && <h2 className="mt-[16px] text-[#373A36] lg:text-center">{heading}</h2>;
    $[2] = heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subheading) {
    t3 = subheading && <p className="mt-[24px] max-w-[700px] text-[19px] font-normal leading-[29px] text-[#4A4A4A] lg:text-center">{subheading}</p>;
    $[4] = subheading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <GridColumn className="md:gap-4"><div className="flex flex-col lg:items-center">{t1}{t2}{t3}</div></GridColumn>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = columns?.leftTitle;
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="bg-[#005472] px-6 py-5 text-center font-work-sans text-[17px] font-bold leading-[28px] text-white">{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = columns?.rightTitle;
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="px-6 py-5 text-center font-work-sans text-[17px] font-bold leading-[28px] text-[#005472]">{t8}</div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className="grid grid-cols-3">{t5}{t7}{t9}</div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== rows) {
    t11 = rows?.map(_temp);
    $[18] = rows;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <GridColumn className="hidden lg:block"><div className="overflow-hidden rounded-md border border-[#D9D9D9]">{t10}{t11}</div></GridColumn>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = columns?.leftTitle;
  let t14;
  if ($[23] !== t13) {
    t14 = <div className="bg-[#005472] px-4 py-4 font-work-sans text-sm font-bold text-white">{t13}</div>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== rows) {
    t15 = rows?.map(_temp2);
    $[25] = rows;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div className="overflow-hidden rounded-md border border-[#D9D9D9]">{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = columns?.rightTitle;
  let t18;
  if ($[30] !== t17) {
    t18 = <div className="px-4 py-4 font-work-sans text-sm font-bold text-[#005472]">{t17}</div>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== rows) {
    t19 = rows?.map(_temp3);
    $[32] = rows;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = <div className="overflow-hidden rounded-md border border-[#D9D9D9]">{t18}{t19}</div>;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t16 || $[38] !== t20) {
    t21 = <GridColumn className="mt-12 lg:hidden"><div className="space-y-4">{t16}{t20}</div></GridColumn>;
    $[37] = t16;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t12 || $[41] !== t21 || $[42] !== t4) {
    t22 = <GridRow className="flex flex-col items-start">{t4}{t12}{t21}</GridRow>;
    $[40] = t12;
    $[41] = t21;
    $[42] = t4;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  return t22;
};
export default ComparisonTable;
function _temp(row) {
  return <div key={row._key} className="grid grid-cols-3 border-t border-[#D9D9D9]"><div className="p-6 font-work-sans text-[17px] font-bold leading-[28px] text-[#373A36]">{row.label}</div><div className="bg-[#F6F7F8] p-6 font-work-sans text-[16px] font-medium leading-[26px] text-[#4A4A4A]">{row.leftValue}</div><div className="p-6 font-work-sans text-[16px] font-medium leading-[26px] text-[#4A4A4A]">{row.rightValue}</div></div>;
}
function _temp2(row_0) {
  return <div key={`left-${row_0._key}`} className="border-t border-[#D9D9D9] px-4 py-4"><div className="font-work-sans text-sm font-bold text-[#202020]">{row_0.label}</div><div className="mt-1 font-work-sans text-sm text-[#4A4A4A]">{row_0.leftValue}</div></div>;
}
function _temp3(row_1) {
  return <div key={`right-${row_1._key}`} className="border-t border-[#D9D9D9] px-4 py-4"><div className="font-work-sans text-sm font-bold text-[#202020]">{row_1.label}</div><div className="mt-1 font-work-sans text-sm text-[#4A4A4A]">{row_1.rightValue}</div></div>;
}